import { BV_SYNDICATED_INCENTIVIZED_REGEX_STR } from '../constants/reviews';

export const isSyndicatedReviewIncentivized = (text?: string) => !!text?.startsWith(BV_SYNDICATED_INCENTIVIZED_REGEX_STR);
export const replaceIncentivizedReviewText = (text?: string) => text?.substring(BV_SYNDICATED_INCENTIVIZED_REGEX_STR.length).trim() ?? '';
